/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LocationFileType {
    SurveyMemo = 1,
    HeadingProfile = 2,
    GroundSupport = 3,
    Other = 4,
    LevelPlan = 5,
}
